import React from 'react'
import { Typography, Chip, Button, CircularProgress } from '@material-ui/core'
import { REVIEW_EVENT_STATUS_LABELS, REVIEW_EVENT_STATUS_COLORS, REVIEW_EVENT_TYPE_LABELS } from '../../constants/contextEnums'

const formatDateTime = (d) => {
  if (!d) return ''
  const dt = new Date(d)
  return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
}

const ReviewsTab = ({ items, loading, onEdit, onComplete }) => {
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No review events.</Typography>
  }

  const handleComplete = (review, e) => {
    e.stopPropagation()
    onComplete(review)
  }

  return items.map((review) => (
    <div
      key={review._id}
      style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
      onClick={() => onEdit('review_event', review)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <Chip
          label={REVIEW_EVENT_STATUS_LABELS[review.status] || review.status}
          size="small"
          style={{ height: 20, fontSize: 11, backgroundColor: REVIEW_EVENT_STATUS_COLORS[review.status] || '#9e9e9e', color: '#fff' }}
        />
        <Chip label={REVIEW_EVENT_TYPE_LABELS[review.event_type] || review.event_type} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />
      </div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>{review.title}</div>
      {review.starts_at && <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>{formatDateTime(review.starts_at)}</div>}
      {review.attendees && review.attendees.length > 0 && (
        <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>{review.attendees.length} attendee{review.attendees.length !== 1 ? 's' : ''}</div>
      )}
      {review.status === 'scheduled' && (
        <Button
          size="small"
          style={{ textTransform: 'none', fontSize: 11, marginTop: 4, color: 'var(--ok)' }}
          onClick={(e) => handleComplete(review, e)}
        >
          Complete
        </Button>
      )}
    </div>
  ))
}

export default ReviewsTab
